import classnames from 'classnames';
import type { CSSProperties, FunctionComponent } from 'react';
import type { RichTextFormatter } from '@/core/localization/translate';
import { Image } from '@/domains/core/Image/Image';
import { isB2C } from '@/domains/core/settings/utils';
import { EXPERTS } from '@/domains/digitalAdvice/Experts/constants';
import ManomanoLogo from './assets/manomano-logo.svg?url';
import ManomanoProLogo from './assets/manomano-pro-logo.svg?url';
import { subtitle, team, title } from './translations.default';
import styles from './ProgrammaticAdviceRecoHeader.module.scss';
export interface ProgrammaticAdviceRecoHeaderProps {
  className?: string;
}
export const ProgrammaticAdviceRecoHeader: FunctionComponent<ProgrammaticAdviceRecoHeaderProps> = ({
  className
}) => {
  const {
    expertName,
    expertHDShot
  } = EXPERTS.nicolas;
  const formatTeam = (): {
    logo: RichTextFormatter;
  } => ({
    logo: () => <Image alt="ManoMano logo" className={styles.logo} height={16} key="manomano-logo" src={isB2C() ? ManomanoLogo : ManomanoProLogo} width={72} />
  });
  return <div className={classnames(styles.root, className)}>
      <div className={styles.content}>
        <div className={styles.details}>
          <div className={styles.expert}>{expertName}</div>
          {team.format(formatTeam())}
        </div>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
      <div className={styles.avatar} data-testid="avatarIcon" style={{
      '--avatar': `url(${expertHDShot})`
    } as CSSProperties} />
    </div>;
};